import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = { class: "prod-cost" };
var _hoisted_2 = { class: "prod-cost__wrap" };
var _hoisted_3 = { class: "prod-cost__price" };
var _hoisted_4 = {
    key: 0,
    class: "prod-cost__price-changes"
};
var _hoisted_5 = { class: "prod-cost__price-old" };
var _hoisted_6 = { class: "tooltip-wrapper" };
var _hoisted_7 = { class: "prod-cost__price-new" };
var _hoisted_8 = {
    key: 0,
    class: "prod-cost__parts"
};
var _hoisted_9 = { class: "prod-cost__parts-value" };
var _hoisted_10 = {
    type: "button",
    class: "btn btn--4 btn--m btn--black btn--link btn--icon win",
    "data-act": "bnpl_info",
    "aria-label": "Подробности"
};
var _hoisted_11 = { class: "btn__icon" };
var _hoisted_12 = { class: "prod-cost__in-cart" };
var _hoisted_13 = ["disabled"];
var _hoisted_14 = { class: "btn__label" };
import { handleAddToCartButtonClick } from "../../../components/product/add_to_cart";
import Price from "../../../components/Price.vue";
import Icon from "../../../components/Icon.vue";
import { computed, useTemplateRef } from "vue";
import Tooltip from "../../../components/Tooltip.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OfferPrice',
    props: {
        offer: { type: Object, required: true },
        buttonCallback: {
            type: Function,
            default: function (offer) { return handleAddToCartButtonClick({ id: offer.id }); }
        },
        buttonLabel: { type: String, default: 'В корзину' },
        buttonDisabled: { type: Boolean },
        noBnplBlock: { type: Boolean, default: false },
    },
    setup: function (__props) {
        var props = __props;
        var button = useTemplateRef('button');
        var discountButton = useTemplateRef('discountButton');
        var discountText = computed(function () {
            return props.offer.personalDiscount
                ? "Персональная скидка "
                : "Скидка по акции ";
        });
        var discountButtonClass = computed(function () { return [
            "prod-cost__discount",
            "tooltip-btn",
            props.offer.personalDiscount ? "prod-cost__discount--my" : "prod-cost__discount--main",
        ]; });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (__props.offer.basePrice && __props.offer.basePrice != __props.offer.price)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(Price, {
                                        amount: __props.offer.basePrice
                                    }, null, 8 /* PROPS */, ["amount"])
                                ]),
                                _cache[2] || (_cache[2] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: _normalizeClass(discountButtonClass.value),
                                        ref_key: "discountButton",
                                        ref: discountButton,
                                        "aria-describedby": "tooltip-discount"
                                    }, "\n              -" + _toDisplayString(__props.offer.discountPercent) + "%\n            ", 3 /* TEXT, CLASS */),
                                    _cache[1] || (_cache[1] = _createTextVNode()),
                                    _createVNode(Tooltip, {
                                        button: discountButton.value,
                                        small: "",
                                        top: "",
                                        id: "tooltip-discount"
                                    }, {
                                        default: _withCtx(function () { return [
                                            _createTextVNode(_toDisplayString(discountText.value) + " ", 1 /* TEXT */),
                                            _createElementVNode("strong", null, [
                                                _createVNode(Price, {
                                                    amount: __props.offer.basePrice - __props.offer.price
                                                }, null, 8 /* PROPS */, ["amount"])
                                            ])
                                        ]; }),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["button"])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(Price, {
                                amount: __props.offer.price
                            }, null, 8 /* PROPS */, ["amount"])
                        ])
                    ]),
                    _cache[7] || (_cache[7] = _createTextVNode()),
                    (!__props.noBnplBlock)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("span", _hoisted_9, [
                                _createVNode(Price, {
                                    amount: Math.floor(__props.offer.price / 4)
                                }, null, 8 /* PROPS */, ["amount"])
                            ]),
                            _cache[4] || (_cache[4] = _createTextVNode()),
                            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "prod-cost__parts-label" }, "× 4 платежа", -1 /* CACHED */)),
                            _cache[6] || (_cache[6] = _createTextVNode()),
                            _createElementVNode("button", _hoisted_10, [
                                _createElementVNode("span", _hoisted_11, [
                                    _createVNode(Icon, {
                                        name: "question",
                                        size: 20
                                    })
                                ])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true),
                    _cache[8] || (_cache[8] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_12, [
                        _renderSlot(_ctx.$slots, "default", {}, function () { return [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn--1 btn--l btn--black",
                                disabled: __props.buttonDisabled,
                                ref_key: "button",
                                ref: button,
                                onClick: _cache[0] || (_cache[0] = _withModifiers(function () { return __props.buttonCallback(__props.offer, button.value); }, ["prevent"]))
                            }, [
                                _createElementVNode("span", _hoisted_14, _toDisplayString(__props.buttonLabel), 1 /* TEXT */)
                            ], 8 /* PROPS */, _hoisted_13)
                        ]; })
                    ])
                ])
            ]));
        };
    }
});
